// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","792":"main"}[chunkId] + "." + {"96":"b7202af17df88d88e272","792":"fef1aac2ac1c15a1e3eb"}[chunkId] + ".css";
};